import { Action, createAction, handleActions } from "redux-actions";
import { TakeValue } from "../types";

interface FiltrosUsuariosState {
  page: number;
  take: TakeValue;
  searchCriteria: string;
  getOnlyActivos: boolean;
  isLoading?: boolean;
}

const setInitialStateUsuarios = createAction(
  "SET_INITIAL_STATE_FILTRO_USUARIOS"
);

const setPage = createAction("SET_LISTADO_USUARIOS_PAGE", (page: number) => ({
  page,
}));

const setTake = createAction(
  "SET_LISTADO_USUARIOS_ROWS_PER_PAGE",
  (take: TakeValue) => ({
    take,
  })
);

const selectSearchCriteria = createAction(
  "SELECT_SEARCH_CRITERIA_FILTRO_USUARIOS",
  (searchCriteria: string) => ({
    searchCriteria,
  })
);

const setGetOnlyActivos = createAction(
  "SET_GET_ONLY_INACTIVOS",
  (getOnlyActivos: boolean) => ({ getOnlyActivos })
);

const filtrosUsuariosInitialState: FiltrosUsuariosState = {
  page: 0,
  take: 10,
  searchCriteria: "",
  getOnlyActivos: true,
};

const filtrosUsuariosReducer = handleActions<FiltrosUsuariosState, any>(
  {
    [setInitialStateUsuarios.toString()]: (): FiltrosUsuariosState => {
      return {
        ...filtrosUsuariosInitialState,
      };
    },
    [setPage.toString()]: (
      state: FiltrosUsuariosState,
      action: Action<{ page: number }>
    ): FiltrosUsuariosState => {
      return {
        ...state,
        page: action.payload.page,
      };
    },
    [setTake.toString()]: (
      state: FiltrosUsuariosState,
      action: Action<{ take: TakeValue }>
    ): FiltrosUsuariosState => {
      return {
        ...state,
        page: 0,
        take: action.payload.take,
        isLoading: false,
      };
    },
    [selectSearchCriteria.toString()]: (
      state: FiltrosUsuariosState,
      action: Action<{ searchCriteria: string }>
    ): FiltrosUsuariosState => {
      return {
        ...state,
        searchCriteria: action.payload.searchCriteria,
      };
    },
    [setGetOnlyActivos.toString()]: (
      state: FiltrosUsuariosState,
      action: Action<{ getOnlyActivos: boolean }>
    ): FiltrosUsuariosState => {
      return {
        ...state,
        getOnlyActivos: action.payload.getOnlyActivos,
      };
    },
  },
  filtrosUsuariosInitialState
);

export { filtrosUsuariosReducer };
export {
  selectSearchCriteria,
  setInitialStateUsuarios,
  setPage,
  setTake,
  setGetOnlyActivos,
};
